jQuery.browser = {};
(function () {
    jQuery.browser.msie = false;
    jQuery.browser.version = 0;
    if (navigator.userAgent.match(/MSIE ([0-9]+)\./)) {
        jQuery.browser.msie = true;
        jQuery.browser.version = RegExp.$1;
    }
})();

$(document).ready(function(){
	$(window).load(function(){
		//AOS.init();
		$('.carousel').carousel({
			autoplay:true,
  			autoplaySpeed:100
		});

	});
});
$(document).ready(function(){
	$(window).load(function(){
		//AOS.init();
		// $('.carousel').carousel({
		// 	interval: 99
		// });

	});

	// CODES THAT INCLUDE ON LOAD AND RESIZE AT THE SAME TIME
	var resizeTimer;

	$(window).on('load resize', function(e){
		clearTimeout(resizeTimer);

		resizeTimer = setTimeout(function() {
			// Run code here, resizing has "stopped"

			// var $pageHeight = $(window).height(),
			// $pageWidth = $(window).width(),
			// $navHeight = $('header.main-header').outerHeight(),
			// $footerHeight = $('footer.footer').outerHeight(),
			// $mainWrapper = $('.wrapper-holder');

			// if( $mainWrapper.hasClass('not-sticky') ) {
			// 	$('.wrapper-holder').css({
			// 		'min-height': $pageHeight - $navHeight,
			// 		'padding-bottom': $footerHeight
			// 	});
			// } else {
			// 	$('.wrapper-holder').css({
			// 		'min-height': $pageHeight - $navHeight,
			// 		'margin-top': $navHeight,
			// 		'padding-bottom': $footerHeight
			// 	});
			// }

			$('.fl-sliders').each(function(){
				// $('.single-page-layout .slider-holder .slide-item').css({
				// 	'min-height' : $pageHeight - ( $footerHeight + $navHeight ),
				// });
	    	var flwidth = $(this).width(),
	    	flnav = $(this).find('.fl-nav'),
	    	flmain = $(this).find('.fl-main'),
	    	dtControl = $(this).data('control'),
	    	dtSpeed = $(this).data('speed'),
	    	dtMargin = $(this).data('item-margin'),
	    	dtDirectionNav = $(this).data('direction-nav'),
	    	dtLoop = $(this).data('looped');

	    	flmain.flexslider({
		      animation: "slide",
		      controlNav: dtControl,
		      animationLoop: dtLoop,
		      slideshow: true,
		      directionNav : dtDirectionNav,
		      itemWidth: flwidth / 6,
		      slideshowSpeed: dtSpeed,
		      itemMargin: dtMargin,
		      prevText: '',
		      nextText: ''
		    });
	    });

		}, 250);

		// careers
		$('.career-btn').click(function(){
			var $careerTitle = $(this).siblings('.career-title').text();

			$('#careerModal').on('show.bs.modal', function(){
				$(this).find('.header-title').text( $careerTitle );
				$(this).find('.hidden-job').val( $careerTitle );
			});

		});

		// Contact Forms
		$('.wpcf7-form').each(function(){
			if( !$(this).find('.file-label').length ) {
				$(this)
					.find('.wpcf7-file')
						.wrap('<label class="file-label"></label>')
					.end()
					.find('.file-label')
						.prepend('<span class="btn file-btn">Browse</span>')
						.append('<small>Send us your resume.</small>')
					.end()
					.change(function(){

						var $fileName = $(this).find('.wpcf7-file').val();

						$(this).find('.file-label small').text( $fileName );

					});
			}
		});

		// Product Categories Sidebar
		$('.product-categories')
			.find('> li:not(li.current-cat):not(li.current-cat-parent)')
				.each(function(){
					$(this).append('<span class="fa fa-plus-circle"></span>');
					$(this).find('.fa').click(function(){
						if( $(this).siblings('.children').length ) {
							$(this).toggleClass('fa-minus-circle fa-plus-circle');
							$(this).siblings('.children').toggle('slide');
						}
					});
				})
			.end()
			.find('> li.current-cat, > li.current-cat-parent')
				.append('<span class="fa fa-minus-circle"></span>')
				.find('.fa').click(function(){
					$(this).toggleClass('fa-plus-circle fa-minus-circle');
					$(this).siblings('.children').toggle('slide');
				});


		// recurring events
		clearTimeout( $.data( this, "deviceCheck" ) );
		$.data(this,  "deviceCheck", setTimeout(function(){

			/**
			*	Slide Categories
			**/

			// add next and prev button on slider
			if( !$('.related.products .slide-controls').length ) {
				$('.related.products').append('<div class="slide-controls">' +
						'<a id="prev" class="pull-left" href="javascript:void;"><span class="fa fa-angle-left"></span></a>' +
						'<a  id="next" class="pull-right" href="javascript:void;"><span class="fa fa-angle-right"></span></a>' +
					'</div>'
				);
			}

			// carousel
			$('.prodcat-list, .related .products').carouFredSel({
				responsive: true,
				circular: true,
				infinite: true,
				auto: false,
				prev: '#prev',
				next: '#next',
				items: {
					visible: {
						min: 1,
						max: 4
					},
					width: 340,
					height: 190
				},
				scroll: {
					items: 1
				},
				height: 'auto'
			});
			var $footerHeight = $('.footer').outerHeight();

			// global inquiry button
			if( Modernizr.mq('(max-width: 1199px)') ) {
				$('.inquire-btn')
					.attr('data-toggle', 'modal')
					.attr('data-target', '#talkToUs')
					.addClass('hasModal');
			}
			else {
				$('.inquire-btn')
					.removeAttr('data-toggle')
					.removeAttr('data-target')
					.removeClass('hasModal');
			}

		}, 100));

	});

	// global inquiry
	$('.inquire-btn').on('click', function(){
		if( !$(this).hasClass('hasModal') ) {
			$('.inquire-wrapper').toggle('fade');
		}
	});

	// header
	$('.search-btn').click(function(){
		// get the header height
		var $headerHeight = $('.main-header').outerHeight();

		$('.search-wrapper-overlay')
			.slideToggle()
			.find('.form-control')
				.focus();

	});


	// single product
	$('.main-img-wrapper').each(function(){
		$(this).zoom({
			magnify: 3
		});
	});

	$('.thumbnails img').click(function(){

		$('.thumbnails img').removeClass('active');
		$(this).addClass('active');

		var $url = $(this).attr('src');

		$('.main-img-wrapper img').attr('src', $url);

	});

	if( $('.fancybox').length > 0 ) {
		$('.fancybox').fancybox();
	}

    $('.woo-maincontent .btn-lg').click(function(){
    	var $title = $('.product_title').text();

    	$('#inquireModal').on('shown.bs.modal', function(){
    		$('#inquireModal .form-title').text('Inquire about ' + $title);
    	});
    });

    $('.main-header .website-details .btn').click(function(){

    	var $title = 'Inquire about a product';

    	$('#inquireModal').on('shown.bs.modal', function(){
    		if( $('body').hasClass('single-product') ) {
    			$title = 'Inquire about ' + $('.product_title').text();
    		}
    		$('#inquireModal .form-title').text($title);
    	});
    });

});